<template>
    <Drawer :title="$t('变更记录')"
            v-model="model"
            width="1000"
            :mask-closable="false"
            class="changeLog">
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr">
        </rcTable>
    </Drawer>
</template>
<script>
import API from '@/service/api'
import rcTable from '@/views/components/basic/rcTable'
export default {
    name: 'ChangeRecord',
    components: {
        rcTable
    },
    data () {
        return {
            model: false,
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    },
                    url: this.urlFormat(API.PRODUCTS_RESOURCES_CHANGERECORD),
                    params: {
                        productType: 'HPC-DRP',
                        resourceId: ''
                    }
                },
                columns: [
                    {
                        title: this.$t('时间'),
                        key: 'changeStartTime',
                        columnShow: true,
                        resizable: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 280,
                        render: (h, { row }) => {
                            const { changeStartTime, changeEndTime } = row
                            const txt = `${changeStartTime} - ${changeEndTime}`
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('操作类型'),
                        key: 'changeType',
                        columnShow: true,
                        resizable: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 110,
                        render: (h, { row }) => {
                            const txt = {
                                upgrade: this.$t('扩容'),
                                degrade: this.$t('缩容'),
                                renew: this.$t('续订'),
                                hpc_renew: this.$t('扩容续订')
                            }[row.changeType]
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    },
                    {
                        title: this.$t('操作结果'),
                        key: 'status',
                        columnShow: true,
                        resizable: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 120,
                        render: (h, { row }) => {
                            // const color = row.status === '1' ? 'green' : 'red'
                            const txt = row.status === '1' ? '成功' : '失败'
                            return h('statusview', {
                                props: {
                                    state: row.status,
                                    stateName: this.$t(txt)
                                }
                            })
                        }
                    },
                    // {
                    //     title: this.$t('变更前'),
                    //     key: 'originalExtra',
                    //     columnShow: true,
                    //     resizable: true,
                    //     sortable: false,
                    //     columnsChoosed: true,
                    //     disabledSearch: true,
                    //     className: 'ellipsis',
                    //     width: 120,
                    //     render: (h, { row }) => {
                    //         const dataObj = JSON.parse(row.originalExtra || '{}')
                    //         return Object.keys(dataObj).sort().map(key => {
                    //             const txt = `${key}: ${dataObj[key]}`
                    //             return h('p', { attrs: { title: txt } }, txt)
                    //         })
                    //     }
                    // },
                    // {
                    //     title: this.$t('变更后'),
                    //     key: 'newExtra',
                    //     columnShow: true,
                    //     resizable: true,
                    //     sortable: false,
                    //     columnsChoosed: true,
                    //     disabledSearch: true,
                    //     className: 'ellipsis',
                    //     width: 120,
                    //     render: (h, { row }) => {
                    //         const dataObj = JSON.parse(row.newExtra || '{}')
                    //         return Object.keys(dataObj).sort().map(key => {
                    //             const txt = `${key}: ${dataObj[key]}`
                    //             return h('p', {
                    //                 attrs: { title: txt }
                    //             }, txt)
                    //         })
                    //     }
                    // },
                    {
                        title: this.$t('变更数量'),
                        key: 'changeExtra',
                        columnShow: true,
                        resizable: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 170,
                        render: (h, { row }) => {
                            const dataObj = JSON.parse(row.changeExtra || '{}')
                            const arr = []
                            Object.keys(dataObj).sort().map(key => {
                                const txt = `${key}: ${dataObj[key]}`
                                arr.push(h('p', {
                                    attrs: { title: txt }
                                }, txt)
                                )
                            })
                            const dataBefore = JSON.parse(row.originalExtra || '{}')
                            const arrBefore = []
                            Object.keys(dataBefore).sort().map(key => {
                                const txt = `${key}: ${dataBefore[key]}`
                                arrBefore.push(h('p', {
                                    attrs: { title: txt }
                                }, txt)
                                )
                            })
                            const dataAfter = JSON.parse(row.newExtra || '{}')
                            const arrAfter = []
                            Object.keys(dataAfter).sort().map(key => {
                                const txt = `${key}: ${dataAfter[key]}`
                                arrAfter.push(h('p', {
                                    attrs: { title: txt }
                                }, txt)
                                )
                            })
                            return h('div', [
                                h('div', {
                                    style: {
                                        display: 'inline-block',
                                        float: 'left'
                                    }
                                }, arr),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [
                                    h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            color: '#2d8cf0',
                                            'margin-left': '10px',
                                            display: 'inline-block',
                                            'margin-top': '21px'
                                        }
                                    }),
                                    h('div', { slot: 'content' }, [
                                        h('div', [
                                            h('div', {
                                                style: {
                                                    display: 'inline-block',
                                                    'padding-right': '20px'
                                                }
                                            }, [
                                                h('p', {
                                                    style: {
                                                        'text-align': 'center',
                                                        'padding-bottom': '3px'
                                                    }
                                                }, '变更前'),
                                                h('div', arrBefore)
                                            ]),
                                            h('div', {
                                                style: {
                                                    display: 'inline-block'
                                                }
                                            }, [
                                                h('p', {
                                                    style: {
                                                        'text-align': 'center',
                                                        'padding-bottom': '3px'
                                                    }
                                                }, '变更后'),
                                                h('div', arrAfter)
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        }
                    },
                    {
                        title: this.$t('配置'),
                        key: 'configDesc',
                        columnShow: true,
                        resizable: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        minWidth: 350,
                        render: (h, { row }) => {
                            const dataObj = JSON.parse(row.configDesc || '{}')
                            return Object.keys(dataObj).sort().map(key => {
                                const txt = `${key}: ${dataObj[key]}`
                                return h('p', {
                                    attrs: { title: txt }
                                }, txt || '--')
                            })
                        }
                    },
                    {
                        title: this.$t('操作人'),
                        key: 'updatedBy',
                        columnShow: true,
                        resizable: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 100,
                        render: (h, { row }) => {
                            const txt = row.updatedBy || '--'
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    }
                ]
            }
        }
    },
    methods: {
        open (data) {
            this.model = true
            this.data = data
            Object.assign(this.tableAttr.source, {
                type: 'get',
                params: {
                    productType: 'HPC-DRP',
                    resourceId: data.clusterId
                }
            })

            this.$refs.rcTable.init()
        },
        // 刷新列表
        refresh () {
            this.$refs.rcTable.refreshTable()
        }
    },
    watch: {
        model (val) {
            if (!val) {
                Object.assign(this.tableAttr.source, {
                    type: 'staticData'
                })
            }
        }
    }
}
</script>
<style lang="less">
.changeLog .newRcTable .rcTable-content .ellipsis > div.ivu-table-cell {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
}
</style>
